import { render, staticRenderFns } from "./B2CV2TrendPanel.vue?vue&type=template&id=4b4e2a32&scoped=true&"
import script from "./B2CV2TrendPanel.vue?vue&type=script&lang=js&"
export * from "./B2CV2TrendPanel.vue?vue&type=script&lang=js&"
import style0 from "./B2CV2TrendPanel.vue?vue&type=style&index=0&id=4b4e2a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e2a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VBtnToggle,VCard,VProgressCircular,VSelect,VSpacer,VSwitch})
